<template lang="pug">
AppPopover(
  ref="AppPopover"
  root-class="time-entries-project-switcher-popover"
  lazy
  @hide="close"
  @click="open"
)
  template(slot="body")
    ValidationObserver(ref="dialogObserver")
      .time-span-popover.time_entry_form
        .row.mb-10
          .col-sm-12.name.strong Reassign time
        .row.mb-15
          .col-sm-12
            TimeEntriesTaskSelect(
              v-model="taskId"
              :project-id="projectId"
              :initial-options="tasks"
              :user-id="timeEntry.user_id"
              :required="taskRequiredForTimeEntry"
            )
        .row
          .col-xs-12
            TimeEntriesTextarea(
              v-model="note"
              name="note"
              label="Reason"
              placeholder="Why are you adding this time entry? (ex: Forgot to start timer)"
              :required="reasonRequiredForTimeEntry"
            )

        .row
          .col-xs-12
            button.btn.btn-success.btn-block.btn-sm(@click="save") Apply
        .curtain(v-show="saving")
          .spinner-wrapper
            span.hi.hi-spinner.hi-32.text-blue
  template(slot="trigger")
    slot(name="trigger")
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeEntriesTaskSwitcherPopover',
  props: {
    timeEntry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      projectId: null,
      taskId: null,
      note: '',
      saving: false,
      errorMessage: 'There was an error when updating this time entry',
      successMessage: 'Time entry updated',
    };
  },
  computed: {
    ...mapGetters(['getProject', 'tasks']),
    project() {
      return this.getProject(this.projectId);
    },
    taskRequiredForTimeEntry() {
      return this.project ? this.project.tasks_required : false;
    },
    reasonRequiredForTimeEntry() {
      return this.project && this.project.reason_required;
    },
  },
  created() {
    this.reset();
  },
  methods: {
    async save() {
      const isValid = await this.$refs.dialogObserver.validate();

      if (isValid) {
        const success = this.success;
        const error = () => this.$appMessage(this.errorMessage);
        const fin = () => {
          this.saving = false;
        };

        this.saving = true;
        const params = { time_entry: { note: this.note, task_id: this.taskId, reassign_time: true } };

        this.$store.dispatch('editTimeEntry', { id: this.timeEntry.id, params }).then(success, error).then(fin);
      }
    },
    success(response) {
      if (response.action === 'error-response') {
        const errors = response.errors;

        this.$refs.dialogObserver.setErrors(errors);
        this.$appMessage(response.alert);
      } else {
        this.$appMessage(this.successMessage);
        this.$store.dispatch('loadData');
      }
      this.$refs.AppPopover.close();
    },
    reset() {
      this.projectId = this.timeEntry.project_id;
      this.taskId = this.timeEntry.task_id;
      this.note = '';
      this.saving = false;
      if (this.$refs.dialogObserver) {
        this.$refs.dialogObserver.reset();
      }
    },
    close() {
      this.reset();
    },
    open() {
      this.$refs.AppPopover.close();
      this.reset();
    },
  },
};
</script>
